
<template lang="html">
<ul class="nav nav-pills col-12 mb-2 p-0">
    <li class="nav-item btn-square col-6 m-0 p-0" @click="occasionsTabSelected">
        <a class="nav-link text-center" v-bind:class="{active: selectedEventTab === 'occasion'}">Occasions</a>
    </li>
    <li class="nav-item btn-square col-6 m-0 p-0" @click="eventsTabSelected">
        <a class="nav-link text-center" v-bind:class="{active: selectedEventTab === 'event'}">Events</a>
    </li>
</ul>
</template>     

<script>
export default {
    name: 'EventTypeTabs',

    props: {
        defaultSelectedTab: ''
    },

    data: function() {
        return {
            selectedEventTab: ''
        }
    },

    mounted: function() {
        this.selectedEventTab = this.defaultSelectedTab;
        if (!this.selectedEventTab || this.selectedEventTab === '' || this.selectedEventTab === 'occasion')
            this.occasionsTabSelected();
        else
            this.eventsTabSelected();
    },

    methods: {
        occasionsTabSelected: function() {
            this.selectedEventTab = 'occasion';
            this.$emit('eventTypeSelection', 'occasion');
        },

        eventsTabSelected: function() {
            this.selectedEventTab = 'event';
            this.$emit('eventTypeSelection', 'event');
        }
    }
}
</script>

<style scoped>
a.nav-link {
  color: #000;
  font-family: 'bariolbold';
  font-size: 18px;
}

.nav-pills .nav-link {
  border-radius: 0;
}

.nav-pills .nav-link.active {
  background-color: #fff;
  color: #F57C33;
  border-bottom: 2px solid;
  border-color: #F57C33;
}

.nav-item, .nav-item:hover {
  color: #F57C33;
  cursor: pointer;
}


</style>